import { FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BREAKPOINTS, useViewport } from "@utils/helpers/breakpoints-helper";
import HeaderOfficeDropdown from "@components/core/headers/HeaderOfficeDropdown";
import HeaderUserDropdown from "@components/core/headers/HeaderUserDropdown";
import BasicLink from "@components/core/links/BasicLink";
import { ROUTES } from "@routes/Routes";
import { logout } from "@state/auth/AuthEvents";
import LogoutIcon from "@static/core/icons/icon-logout.svg?react";

interface SideMenuProps {
  isSideMenuOpen: boolean;
  dropdownOpen: string | undefined;
  changeDropdownOpen: (dropdown: string) => void;
  className?: string;
}

const SideMenu: FunctionComponent<SideMenuProps> = ({
  isSideMenuOpen,
  dropdownOpen,
  changeDropdownOpen,
  className = "",
}) => {
  const { t } = useTranslation();
  const { width } = useViewport();

  useEffect(() => {
    const body = document.body;
    if (isSideMenuOpen && width < BREAKPOINTS.md) {
      body.classList.add("overflow-hidden");
    } else {
      body.classList.remove("overflow-hidden");
    }
  }, [isSideMenuOpen, width]);

  return (
    <div
      className={`app-sidemenu ${
        isSideMenuOpen ? "sidemenu-open" : ""
      } ${className}`}
    >
      <div className="sidemenu-container flex-grow-1 d-flex flex-column">
        <div className="links flex-grow-1 d-flex flex-column">
          <HeaderOfficeDropdown
            show={dropdownOpen === "office"}
            setShow={() => changeDropdownOpen("office")}
          />
          <HeaderUserDropdown
            show={dropdownOpen === "user"}
            setShow={() => changeDropdownOpen("user")}
          />
          <div className="user">
            <BasicLink
              to={ROUTES.auth.login.generate()}
              onClick={() => logout()}
              className="user-logout"
            >
              <>
                <LogoutIcon className="icon-logout" />
                {t("header.logout")}
              </>
            </BasicLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideMenu;
